import { useMemo } from "react"

export const useDropdownList = list => {
  return useMemo(() => {
    return list
      .filter(item => item.isShown)
      .map(({ img, index, title }) => ({
        icon: img,
        value: index,
        label: title,
      }))
  }, [list])
}
